import { render, staticRenderFns } from "./ProjectControlLeaveModal.vue?vue&type=template&id=47a6c1fb&scoped=true&"
import script from "./ProjectControlLeaveModal.vue?vue&type=script&lang=js&"
export * from "./ProjectControlLeaveModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectControlLeaveModal.vue?vue&type=style&index=0&id=47a6c1fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6c1fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a6c1fb')) {
      api.createRecord('47a6c1fb', component.options)
    } else {
      api.reload('47a6c1fb', component.options)
    }
    module.hot.accept("./ProjectControlLeaveModal.vue?vue&type=template&id=47a6c1fb&scoped=true&", function () {
      api.rerender('47a6c1fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/ProjectControlLeaveModal.vue"
export default component.exports